import { PublicKey } from "@solana/web3.js";

/**
 * An empty mint list signals "all mints" to the market-stats and collateral-yield routes,
 * letting those queries fire on mount instead of waiting for the token list to resolve.
 * Shared module-level constant so the RTK Query arg stays reference-stable across renders.
 * Lives in this leaf package (not abf-react) so module-init reads can't hit a circular-import TDZ.
 */
export type AllMints = string[];
export const ALL_MINTS: AllMints = [];

export const USDC_MINT = "EPjFWdd5AufqSSqeM2qN1xzybapC8G4wEGGkZwyTDt1v";
export const WRAPPED_SOL_MINT = "So11111111111111111111111111111111111111112";
export const STAKED_SOL_MINT = "sTSoN7tYft63PJjHw2NcgJ43saq3NiE3XCdfvXXcTrD";
export const JLP_MINT = "27G8MtK7VtTcCHkpASjSDdkWWYfoqT6ggEuKidVJidD4";
export const ONYC_MINT = "5Y8NV33Vv7WbnLfq3zBcKSdYPrk7g2KoiQoe7M2tcxp5";
export const DEFAULT_PUBLIC_KEY = PublicKey.default.toString();

export const SOL_SYMBOL = "SOL";
export const RECOMMENDED_TXN_FEE = "0.001";

export const DEFAULT_PRINCIPAL_MINT = USDC_MINT;
export const SOL_DECIMALS = 9;
export const PERCENT_DECIMALS = 3;

export const MIN_SOL_BALANCE = 0.01;

export const BASE_FEE_LAMPORTS = 5000;

export const DISABLED_APY = "18446744073709551615";
export const DISABLED_APY_BIGINT = BigInt(DISABLED_APY);
